"use client"

import { useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { Header } from "../components/dashboard/header"
import { Sidebar } from "../components/dashboard/sidebar"
import { Container, Spinner } from "react-bootstrap"
import { useAuth } from "../contexts/auth-context"

export default function DashboardLayout() {
  const { isAuthenticated, isLoading } = useAuth()

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navigate = useNavigate()
  const isMobile = window.innerWidth < 768

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/auth/login")
    }
  }, [isLoading, isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <div className="d-flex flex-column flex-md-row min-vh-100">
      {(mobileMenuOpen || !isMobile) && (
        <div className={`${isMobile ? "position-fixed top-0 start-0 bottom-0 w-100 z-3" : "flex-shrink-0"}`}>
          <Sidebar isMobile={isMobile} setMobileMenuOpen={setMobileMenuOpen} />
        </div>
      )}
      <div className="d-flex flex-column flex-grow-1 overflow-hidden gradient-page">
        <Header isMobile={isMobile} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
        <main className="flex-grow-1 overflow-auto" style={{ paddingTop: "60px" }}>
          {/* Updated container padding to px-2 on mobile, px-md-3 on desktop */}
          <Container fluid className="px-2 px-md-3 py-0 h-100">
            <Outlet />
          </Container>
        </main>
      </div>
    </div>
  )
}
